<template>
  <div>
    <h2 class="text-1xl font-bold text-gray-700">
      Cuentas por cobrar aseguradoras
    </h2>
    <MainInsuranceAccountsReceivable />
  </div>
</template>

<script>
import MainInsuranceAccountsReceivable from "@/components/Sales/InsuranceAccountsReceivable/MainInsuranceAccountsReceivable.vue";
import { useRoute } from "vue-router";
import { onBeforeMount, onMounted } from "vue";
import { findSubmoduleIdByDescription } from "@/hisAcces";
export default {
  name: "InsuranceAccountsReceivable",
  components: {
    MainInsuranceAccountsReceivable,
  },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
};
</script>
